<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.attendanceShift.shift') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row mb-3">
            <div class="col-sm-12 col-lg-6 col-md-12">
              <div class="form-group row">
                <label class="col-md-5 form-col-label control-label required">
                  {{ $t('administration.employee.attendanceShift.shiftName') }}
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.shift_name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('shift_name') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('shift_name')">
                    {{ errors.first('shift_name') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-5 form-col-label control-label required">
                  {{ $t('administration.employee.attendanceShift.shiftType') }}
                </label>
                <div class="col-md-7">
                  <select
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('shift_type') }"
                    v-model="model.shift_type"
                  >
                    <option
                      :value="null"
                      disabled
                      selected
                      style="display: none;"
                    >
                      {{ $t('select') }}</option
                    >
                    <option value="Normal">Normal</option>
                    <option value="Shift">Shift</option>
                    <option value="Rotation">Rotation</option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('shift_type')">
                    {{ errors.first('shift_type') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-5 form-col-label control-label required">
                  {{
                    $t('administration.employee.attendanceShift.minuteAllow')
                  }}
                </label>
                <div class="col-md-7">
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="model.minute_allow"
                    :class="{ 'is-invalid': errors.has('minute_allow') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('minute_allow')"
                  >
                    {{ errors.first('minute_allow') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-5 form-col-label control-label"> </label>
                <div class="col-md-7">
                  <ts-checkbox v-model="model.inactive">{{
                    $t('attendanceShift.inactive')
                  }}</ts-checkbox>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12">
            <ts-loading-banner :loading="loadingPreData">
              <div class="overflow-auto" id="container-table">
                <table class="table ui-table table-hover">
                  <thead>
                    <tr>
                      <th class="ts-whitespace-no-wrap" style="width:10%">
                        {{
                          $t('administration.employee.attendanceShift.keyword')
                        }}
                      </th>
                      <th class="ts-whitespace-no-wrap text-center">
                        {{
                          $t('administration.employee.attendanceShift.fromDay')
                        }}
                      </th>
                      <th class="ts-whitespace-no-wrap text-center">
                        {{
                          $t('administration.employee.attendanceShift.toDay')
                        }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width:15%"
                      >
                        {{
                          $t('administration.employee.attendanceShift.firstIn')
                        }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width:15%"
                      >
                        {{
                          $t('administration.employee.attendanceShift.firstOut')
                        }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width:15%"
                      >
                        {{
                          $t('administration.employee.attendanceShift.secondIn')
                        }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width:15%"
                      >
                        {{
                          $t(
                            'administration.employee.attendanceShift.secondOut'
                          )
                        }}
                      </th>
                      <th class="ts-whitespace-no-wrap" style="width:12%">
                        {{
                          $t(
                            'administration.employee.attendanceShift.TotalHours'
                          )
                        }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width: 2%"
                      >
                        <a
                          href="#"
                          class="text-primary"
                          v-tooltip="$t('tooltip.addItem')"
                        >
                          <i class="fa fa-plus" @click.prevent="addNewRow"></i>
                        </a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in model.details" :key="index">
                      <td>
                        <input
                          type="text"
                          :readonly="!requiredKeyword"
                          v-model="item.keyword"
                          class="form-control only-border-bottom"
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.keyword'
                            )
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('details.' + index + '.keyword')"
                        >
                          {{ errors.first('details.' + index + '.keyword') }}
                        </div>
                      </td>
                      <td>
                        <ts-select
                          v-model="item.wd_id_from"
                          :disabled="!requiredWeekDay"
                          class="form-control only-border-bottom"
                          :options="
                            weekDays.map(e => ({
                              text: e.wd_name_en,
                              value: e.wd_id
                            }))
                          "
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.wd_id_from'
                            )
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('details.' + index + '.wd_id_from')"
                        >
                          {{ errors.first('details.' + index + '.wd_id_from') }}
                        </div>
                      </td>
                      <td>
                        <ts-select
                          v-model="item.wd_id_to"
                          :disabled="!requiredWeekDay"
                          class="form-control only-border-bottom"
                          :options="
                            weekDays.map(e => ({
                              text: e.wd_name_en,
                              value: e.wd_id
                            }))
                          "
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.wd_id_to'
                            )
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('details.' + index + '.wd_id_to')"
                        >
                          {{ errors.first('details.' + index + '.wd_id_to') }}
                        </div>
                      </td>
                      <td>
                        <ts-time-picker-input
                          :use24Hour="true"
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.first_in'
                            )
                          }"
                          v-model="item.first_in"
                          @input="item.total_hour = totalHour(item).value"
                        />
                        <div
                          class="validate"
                          v-if="errors.has('details.' + index + '.first_in')"
                        >
                          {{ errors.first('details.' + index + '.first_in') }}
                        </div>
                      </td>
                      <td>
                        <ts-time-picker-input
                          v-model="item.first_out"
                          :use24Hour="true"
                          @input="item.total_hour = totalHour(item).value"
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.first_out'
                            )
                          }"
                        />
                        <div
                          class="validate"
                          v-if="errors.has('details.' + index + '.first_out')"
                        >
                          {{ errors.first('details.' + index + '.first_out') }}
                        </div>
                      </td>
                      <td>
                        <ts-time-picker-input
                          :use24Hour="true"
                          v-model="item.second_in"
                          @input="item.total_hour = totalHour(item).value"
                        />
                      </td>
                      <td>
                        <ts-time-picker-input
                          :use24Hour="true"
                          v-model="item.second_out"
                          @input="item.total_hour = totalHour(item).value"
                        />
                      </td>
                      <td>
                        <input hidden v-model.number="item.total_hour" />
                        <input
                          :value="totalHour(item).description"
                          class="form-control-plaintext"
                        />
                      </td>
                      <td class="text-center">
                        <a
                          href="#"
                          class="text-danger"
                          v-tooltip="$t('tooltip.removeItem')"
                          @click.prevent="removeRow(item)"
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ts-loading-banner>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 text-right">
            <ts-button
              class="btn-primary mr-2"
              @click.prevent="update"
              :waiting="saving"
              v-if="model.details.length"
            >
              {{ $t('update') }}
            </ts-button>
            <ts-button
              class="btn-default"
              @click="$router.push({ name: 'attendance-shift' })"
            >
              {{ $t('cancel') }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'attendance-shift-create',
  data() {
    return {
      model: {
        shift_name: '',
        shift_type: null,
        minute_allow: '',
        inactive: false,
        details: []
      },
      newRow: {
        record_id: 0,
        keyword: '',
        wd_id_from: '',
        wd_id_to: '',
        first_in: '',
        first_out: '',
        second_in: '',
        second_out: '',
        total_hour: ''
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false
    }
  },
  computed: {
    requiredKeyword() {
      if (
        this.model.shift_type === 'Normal' ||
        this.model.shift_type === 'Shift'
      ) {
        this.model.details.map(d => (d.keyword = ''))
        return false
      } else {
        return true
      }
    },

    requiredWeekDay() {
      if (
        this.model.shift_type === 'Rotation' ||
        this.model.shift_type === 'Shift'
      ) {
        this.model.details.map(d => (d.wd_id_from = d.wd_id_to = ''))
        return false
      } else {
        return true
      }
    },

    ...mapGetters('attendanceShift', ['totalHour']),

    ...mapState('attendanceShift', ['edit_data', 'weekDays'])
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('attendanceShift/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
          this.setEditData()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    addNewRow() {
      this.model.details.push(_.clone(this.newRow))
    },
    removeRow(item) {
      this.model.details.splice(this.model.details.indexOf(item), 1)
    },

    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('attendanceShift/update', {
          id: this.edit_data.shift_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'attendance-shift' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },

    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()

        this.model = {
          shift_name: this.edit_data.shift_name,
          shift_type: this.edit_data.shift_type,
          minute_allow: this.edit_data.minute_allow,
          inactive: this.edit_data.inactive,
          details: []
        }
        this.edit_data.details.map(el => {
          this.model.details.push({
            record_id: el.record_id,
            keyword: el.keyword,
            wd_id_from: el.wd_id_from,
            wd_id_to: el.wd_id_to,
            first_in: el.first_in,
            first_out: el.first_out,
            second_in: el.second_in,
            second_out: el.second_out,
            total_hour: el.total_hour
          })
        })
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('attendanceShift/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
#container-table {
  border: 1px solid #EAECEE;
  min-height: 40vh;
	max-height: 50vh;
	overflow-y:scroll;
	overflow-x: hidden;
	scrollbar-width: none;
   -ms-overflow-style: none;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
	table td {
		vertical-align : middle;
	}
	.only-border-bottom {
		border-top: none;
		border-left: none;
		border-right: none;
		outline: none;
	}
	.table > thead > tr > th {
	  position: sticky;
		position: -webkit-sticky;
		top: 0;
		z-index: 2;
	}
	.table > tbody > tr > td{
		padding-top: 5px !important;
		padding-bottom: 5px !important;
    border: none !important;
	}
	#amountValue tr > td{
		padding: 5px;
	}
</style>
